import { __assign, __extends } from "tslib";
import React, { Component } from 'react';
import { Text, Platform } from 'react-native';
import c from '../colors.js';
var PnmacTextMobile = /** @class */function (_super) {
  __extends(PnmacTextMobile, _super);
  function PnmacTextMobile() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  // Needed for when this is the only child of a touchable component
  PnmacTextMobile.prototype.setNativeProps = function (props) {
    this.refs.text.setNativeProps(props);
  };
  PnmacTextMobile.prototype.render = function () {
    var props = this.props;
    return /*#__PURE__*/React.createElement(Text, __assign({
      ref: "text",
      allowFontScaling: true
    }, props, {
      style: [s.text(props), props.style]
    }), props.children);
  };
  return PnmacTextMobile;
}(Component);
var AppTextLink = function (props) {
  return /*#__PURE__*/React.createElement(PnmacTextMobile, __assign({
    darkCyan: true
  }, props));
};
PnmacTextMobile.Link = AppTextLink;
export default PnmacTextMobile;
var s = {
  text: function (props) {
    return {
      fontSize: props.size || 14,
      color: props.white ? c.white : props.blue ? c.blue : props.darkGray ? c.darkGray : props.darkerGray ? c.darkerGray : props.cyan ? c.cyan : props.darkCyan ? c.darkCyan : props.darkerCyan ? c.darkerCyan : props.lightGray ? c.lightGray : props.gray ? c.gray : props.green ? c.green : c.black,
      fontFamily: props.gilroy ? 'gilroy' : props.bold ? 'opensans-bold' : props.thin ? 'opensans-thin' : Platform.OS == "web" ? 'inherit' : 'Montserrat',
      letterSpacing: props.gilroy ? 0 : props.ls ? props.ls : -.2,
      textAlign: props.center ? 'center' : props.right ? 'right' : 'left',
      marginBottom: props.mb || 0,
      fontWeight: props.heavy ? '700' : '400'
    };
  }
};